type Keys = string | number;

type IToken = {
  [key in Keys]: { pattern: RegExp };
};
/**
 *
 * @param mask : The number mask for 1 stand for any number, e.g. 111-1111, (111) 111-11111;
 * @param value: string of numbers, e.g. 1234234
 * @returns Transformed string
 */
export const stringMask = (mask: string, value: string): string => {
  const tokens: IToken = {
    1: { pattern: /\d/ },
  };

  const pattern2 = mask;
  let formatted = '';
  let valuePos = 0;
  let patternPos = 0;

  function hasMoreTokens(pattern: string, pos: number): boolean {
    const patternChar = pattern.charAt(pos);
    const token = tokens[patternChar];
    if (patternChar === '') {
      return false;
    }
    return token ? true : patternPos < value.length && hasMoreTokens(pattern, pos + 1);
  }

  function continueCondition(): boolean {
    if (hasMoreTokens(pattern2, patternPos)) {
      return true;
    }

    return patternPos < pattern2.length && patternPos >= 0;
  }

  /**
   * Iterate over the pattern's chars parsing/matching the input value chars
   * until the end of the pattern.
   */
  for (patternPos = 0; continueCondition(); patternPos += 1) {
    // if match has reached to the end of value string then break the match
    if (valuePos === value.length) {
      break;
    }
    // value char
    const valueChar = value.charAt(valuePos);
    // pattern char to match with the value char
    const pattenChar = pattern2.charAt(patternPos);

    const token = tokens[pattenChar];
    // token not found in tokens configuration
    if (!token) {
      formatted += pattenChar;
    } else if (token.pattern.test(valueChar)) {
      formatted += valueChar;
      valuePos += 1;
    } else {
      // if pattern not match the value
      // move the value char to next
      // and keep the pattern position not move to next
      valuePos += 1;
      patternPos -= 1;
    }
  }

  return formatted;
};
